/*
 * @Descripttion: 
 * @version: 
 * @Author: ybac
 * @Date: 2023-06-06 17:09:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-06-21 10:45:53
 */
/**
 * 项目默认配置项
 * primaryColor - 默认主题色
 * navTheme - sidebar theme ['dark', 'light'] 两种主题
 * colorWeak - 色盲模式
 * layout - 整体布局方式 ['sidemenu', 'topmenu'] 两种布局
 * fixedHeader - 固定 Header : boolean
 * fixSiderbar - 固定左侧菜单栏 ： boolean
 * autoHideHeader - 向下滚动时，隐藏 Header : boolean
 * contentWidth - 内容区布局： 流式 |  固定
 *
 * storageOptions: {} - Vue-ls 插件配置项 (localStorage/sessionStorage)
 *
 */
/* ________________羚羊不同应用隔离-begin________________ */
function myParams(domainURL) {
  let obj = {};
  if (domainURL.indexOf('?') != -1) {
    let newStr = domainURL.slice(domainURL.indexOf('?') + 1); //从?开始截取到最后[不含问号]
    // 将#号转换成格式相同的,并进行分割为数组
    let ary = newStr.replace(/#/g, '&HASH=').split('&');
    for (let i = 0; i < ary.length; i++) {
      // 将ary中的小数组用等号进行拆分
      let tempAry = ary[i].split('=');
      // 判定拆分后的数组第二个字符串是否为数字(当前规则不考虑=0的情况)
      if (!Number(tempAry[1])) { // 为非数字
        obj[tempAry[0]] = tempAry[1];
      } else {
        obj[tempAry[0]] = Number(tempAry[1]); // 是数字则直接转成数字显示
      }
    }
  }
  return obj;
}
let storage = ''
let domainURL = window.location.href
let domainParams = myParams(domainURL)
if (domainParams.token) {
  storage = domainParams.type == 1 ? 'storage__' : ''
}
/* ________________羚羊不同应用隔离-end________________ */

export default {
  primaryColor: '#1890FF', // primary color of ant design
  navTheme: 'light', // theme for nav menu
  layout: 'sidemenu', // nav menu position: sidemenu or topmenu
  contentWidth: 'Fixed', // layout of content: Fluid or Fixed, only works when layout is topmenu
  fixedHeader: false, // sticky header
  fixSiderbar: false, // sticky siderbar
  autoHideHeader: false, //  auto hide header
  colorWeak: false,
  multipage: true, //默认多页签模式
  // vue-ls options
  storageOptions: {
    namespace: `pro__${storage}`, // key prefix
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local', // storage name session, local, memory
  }
}